export function useGeoAvailability() {
  const { countryCode, ip, isAvailable, isReady } = useNuxtApp().$geo
  return { countryCode, ip, isAvailable, isReady }
}
